import { render, staticRenderFns } from "./modal-button-close.vue?vue&type=template&id=bb1f807c&scoped=true&"
import script from "./modal-button-close.vue?vue&type=script&lang=js&"
export * from "./modal-button-close.vue?vue&type=script&lang=js&"
import style0 from "./modal-button-close.vue?vue&type=style&index=0&id=bb1f807c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1f807c",
  null
  
)

export default component.exports